export function isXlsxFile(filename: string): boolean {
  return filename.toLowerCase().endsWith('.xlsx');
}
